import e from "../globals/colors.js";
import r from "../globals/components.js";
const t = {
  // Theme object used by MUI's provider
  palette: {
    mode: "light",
    common: {
      black: e.black,
      white: e.white
    },
    primary: {
      main: e.blue300,
      light: e.blue200,
      dark: e.blue400,
      contrastText: e.white
    },
    secondary: {
      main: e.grey500,
      light: e.grey400,
      dark: e.grey600,
      contrastText: e.white
    },
    grey: {
      50: "#fafafa",
      100: e.grey100,
      200: e.grey200,
      300: e.grey300,
      400: e.grey400,
      500: e.grey500,
      600: e.grey600,
      700: e.grey700,
      800: e.grey800,
      900: e.grey900,
      A100: e.grey200,
      A200: e.grey300,
      A400: e.grey400,
      A700: e.grey600
    },
    background: {
      paper: e.white,
      default: e.white
    }
  },
  // Theme object used by Styled Component's provider
  colors: e,
  isLightTheme: !0,
  secondaryBackground: e.grey200,
  tertiaryBackground: e.grey300,
  primaryFill: e.blue300,
  primaryFocus: e.blue300,
  primaryHover: e.blue400,
  primarySelected: e.blue500,
  primaryDisabled: e.grey300,
  secondaryDisabled: e.grey500,
  primaryShadow: "rgba(0, 0, 0, 0.14)",
  secondaryShadow: "rgba(0, 0, 0, 0.1)",
  plain: e.grey700,
  attention: e.yellow,
  components: r
};
export {
  t as default
};
